import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { ArrowDirection, ArrowIconWithMargin } from '@lean-body/components/atoms';
import { TvIcon } from '../atoms/icons/tv_icon';
import { Link } from 'react-router-dom';
import { routes } from '@lean-body/src/route';
import { tvAnnoucementId } from '@lean-body/src/domain';
export const TvBanner = ({ text, classObject, config }) => {
    return (React.createElement(Link, { to: routes.ANNOUNCEMENT_DETAIL.compile({ id: tvAnnoucementId(config).toString() }), className: css(styles.container, classObject) },
        React.createElement(TvIcon, null),
        React.createElement("p", { className: css(styles.tvAnnouncementText) }, text),
        React.createElement(ArrowIconWithMargin, { classObject: styles.tvAnnouncementArrow, direction: ArrowDirection.right, color: Colors.PrimaryDark })));
};
const styles = StyleSheet.create({
    container: {
        padding: 10,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 6,
        border: `1px solid ${Colors.PrimaryDark}`,
        backgroundColor: Colors.PrimaryLighter,
    },
    tvAnnouncementText: {
        flex: 1,
        marginLeft: 4,
        fontSize: 12,
        fontWeight: 'bold',
        color: Colors.PrimaryDark,
        lineHeight: '160%',
        letterSpacing: '4%',
    },
    tvAnnouncementArrow: {
        width: 20,
        height: 20,
    },
});
